import React from 'react';
import { Box, Flex, Link, Text, VStack } from '@chakra-ui/react';
import { COLORS } from '../../globalvariables';

const Footer = () => {
  return (
    <Box 
      as="footer" 
      w="100%" 
      py={6}
      background={COLORS.footerGradient}
      color={COLORS.footerText}
      zIndex={1}
      position="relative"
      textAlign="center"
      borderTop={`3px solid ${COLORS.footerBorder}`}
    >
      <VStack spacing={4}>
        <Text 
          color="#FFFFFF" 
          fontWeight="bold" 
          fontSize="lg"
          textShadow="0 1px 2px rgba(0,0,0,0.3)"
        >
          &copy; 2025 1000Shake. All rights reserved.
        </Text>
        
        <Flex justify="center" mt={2}>
          <Link 
            href="/privacy" 
            mx={4} 
            color={COLORS.creamText}
            fontWeight="medium"
            fontSize="md"
            _hover={{ 
              textDecoration: 'underline', 
              color: "white",
              transform: "translateY(-2px)",
            }}
            transition="all 0.3s ease"
          >
            Privacy Policy
          </Link>
          <Link 
            href="/terms" 
            mx={4} 
            color={COLORS.creamText}
            fontWeight="medium"
            fontSize="md"
            _hover={{ 
              textDecoration: 'underline', 
              color: "white",
              transform: "translateY(-2px)",
            }}
            transition="all 0.3s ease"
          >
            Terms of Service
          </Link>
        </Flex>
      </VStack>
    </Box>
  );
};

export default Footer; 